import { Pivot, PivotItem, Stack, StackItem, Text } from "@fluentui/react";
import { useState } from "react";
import { RevenueDay } from "./RevenueDay";
import { RevenueMonth } from "./RevenueMonth";

const MONTH_NAMES = [
  "Ocak",
  "Şubat",
  "Mart",
  "Nisan",
  "Mayıs",
  "Haziran",
  "Temmuz",
  "Ağustos",
  "Eylül",
  "Ekim",
  "Kasım",
  "Aralık",
];

export function Emaar() {
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
  const tabItems: JSX.Element[] = [];
  for (let i = 0; i < MONTH_NAMES.length; i++) {
    tabItems.push(
      <PivotItem key={i.toString()} itemKey={i.toString()} headerText={MONTH_NAMES[i]} />
    );
  }
  const monthItems: JSX.Element[] = [];
  const daysInMonth = getDaysInMonth(currentMonth);
  for (let i = 0; i < daysInMonth; i++) {
    monthItems.push(
      <RevenueDay key={`${i}-${currentMonth}`} day={i + 1} month={currentMonth + 1} />
    );
  }

  return (
    <div style={{ padding: "1rem" }}>
      <Stack horizontal tokens={{ childrenGap: 15 }}>
        <StackItem grow>
          <Text variant="xxLarge">Emaar Ciro Raporları</Text>
        </StackItem>
        <StackItem>
          <Pivot
            selectedKey={currentMonth.toString()}
            onLinkClick={(e) => setCurrentMonth(parseInt(e?.props.itemKey || "0"))}
          >
            {tabItems}
          </Pivot>
        </StackItem>
      </Stack>
      <Stack>
        {monthItems}
        <br />
        <RevenueMonth month={currentMonth + 1} />
      </Stack>
    </div>
  );
}

function getDaysInMonth(monthIndex: number) {
  const now = new Date();
  const lastDayOfMonth = new Date(now.getFullYear(), monthIndex + 1, 0).getDate();
  return lastDayOfMonth;
}
